<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="summer">
<h1>Summer</h1>
<p style="text-indent: 00em;">The lawns have been mowed, they look really great</p>
<p style="text-indent: 00em;">’Twas a very hot job done by my mate</p>
<p style="text-indent: 00em;">They grow so fast even though there’s no rain</p>
<p style="text-indent: 00em;">I don’t know why, but it is such a pain</p><br/>
<p style="text-indent: 00em;">The edges are done, and the garden is weeded</p>
<p style="text-indent: 00em;">A good daily watering is now needed</p>
<p style="text-indent: 00em;">It’s a delight to see the flowers so bright</p>
<p style="text-indent: 00em;">And the new added gardens complete the sight</p><br/>
<p style="text-indent: 00em;">Actually, there’re still more gardens to come</p>
<p style="text-indent: 00em;">And the bed for the bulbs is now nearly done</p>
<p style="text-indent: 00em;">But alas! We are not happy when the temperature is high</p>
<p style="text-indent: 00em;">And then when it’s wet and windy, we sigh</p><br/>
<p style="text-indent: 00em;">We must learn to be happy, whatever the case</p>
<p style="text-indent: 00em;">Whether it’s sun, wind, or rain in our face</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch007.vue?171202a2